// import { OfficeDialogMessageType } from "@/common/enums";
import LoadingCustom from "@/components/ui/Loading";

import { HttpResponse } from "@/fetchInterceptor/AxiosMethod";
import { objectToParams } from "@/utilities/Object";

import { useEffect, useState } from "react";
// import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
// import { useSelector } from "react-redux";
// import { RootState } from "@/redux";

interface ISessionResponse {
  SessionId: string;
  Attendees: any[]; // You might want to define a more specific type for attendees
  RecurringInstances: string;
  ConflictResourcesOccurrencesMap: string;
  SelectedResources: string;
  StartTime: string;
  EndTime: string;
  Subject: string;
  OrganizerEmail: string;
  OrganizerName: string;
  TimeZoneCode: string;
  CustomUid: string;
  Language: string;
  GlobalId: string;
  Guid: string;
  ReOpenOrderFormAfterSend: string;
  clientTimeFormat: string;
  clientDateFormat: string;
  clientSeparatorDate: string;
  clientCultureCode: string;
  IsRecurringApp: string;
  Token: string;
  RcEndpoint: string;
  SelectedResourceAdIds: string;
}

const OrderPlanInitial = (props: any) => {
  // const orgStore: IOrganizationStore = useSelector(
  //   (state: RootState) => state.orgInfo
  // ) as IOrganizationStore;
  const [loading, setLoading] = useState<boolean>(true);
  const [rcEndpoint, setRcEndpoint] = useState<string>("");
  const [_sessionData, setSessionData] = useState<any | null>(null);
  const [token, setToken] = useState<any | null>(null);
  const [pendingTokenRequest, setPendingTokenRequest] = useState<boolean>(false);

  useEffect(() => {
    onGetDataSessionForProps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.search, props.onGetDataSession]);

  const onGetDataSessionForProps = async () => {
    const searchParams = new URLSearchParams(window.location.search);
    const paramsObject = Object.fromEntries(searchParams.entries());

    if (props.onGetDataSession && paramsObject?.sessionId) {
      // setLoading(true);
      const resp: HttpResponse<ISessionResponse> = await props.onGetDataSession(paramsObject.sessionId);

      if (!resp.error && resp.data) {

        const { Token, RcEndpoint, SelectedResources, ...sessionDataWithoutTokenAndRcEndpoint } = resp.data;
        console.log("🚀 ~ onGetDataSessionForProps :", RcEndpoint, SelectedResources)

        setRcEndpoint(RcEndpoint);
        setToken(Token);
        setSessionData(sessionDataWithoutTokenAndRcEndpoint);
        setLoading(false);

      }
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pendingTokenRequest && token) {
      const iframe = document.getElementById("myIframe") as HTMLIFrameElement;
      iframe?.contentWindow?.postMessage(
        {
          type: "TOKEN",
          data: token,
        },
        "*"
      );
      setPendingTokenRequest(false);
    }
  }, [token, pendingTokenRequest]);

  const handleMessage = (event: any) => {
    if (event?.data?.type === "ACTION") {
      const messageObject = JSON.parse(event?.data?.data);
      // const messageObject = event?.data?.data
      props.messageToParent && props.messageToParent(messageObject);
    }
    // else if (event?.data?.type === "CLOSE") {
    //   const messageObject = { MessageType: OfficeDialogMessageType.CloseDialog };
    //   props.messageToParent && props.messageToParent(messageObject)
    // }
    else if (event?.data?.type === "REQUEST_TOKEN") {
      setPendingTokenRequest(true);
    }
  };

  return loading ? (
    <LoadingCustom />
  ) : (
    <>
      <Iframe source={rcEndpoint + "/ResourceCentral/OfficeAddin/OneStopOrder/OfficePlace?" + objectToParams(_sessionData ? _sessionData : {})} />

      {/*  <Iframe
        source={"http://localhost:80" + "/ResourceCentral/OfficeAddin/OneStopOrder/OfficePlace?" + objectToParams(_sessionData ? _sessionData : {})}
      /> */}
    </>
  );
};

const Iframe = ({ source }: any) => {
  if (!source) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <iframe id="myIframe" style={{ width: "100%", maxHeight: "100vh", minHeight: "100vh", backgroundColor: "#fff", border: 0 }} src={source}></iframe>
    </div>
  );
};

export default OrderPlanInitial;
